import { ComponentType } from "react";

import type { RouteObject } from "react-router";

type Route = RouteObject & {
  name: string;
  path: string;
  lazy: () => Promise<{ Component: ComponentType<ExplicitAny> }>;
  isCatchAllRoute?: boolean;
};

const allRoutes: Route[] = [
  // public pages
  {
    name: "PermissionError",
    path: "/403",
    lazy: async () => {
      const { PermissionErrorPage } = await import(
        "@/components/pages_public/403"
      );
      return { Component: PermissionErrorPage };
    },
  },
  {
    name: "LogIn",
    path: "/login",
    lazy: async () => {
      const { LoginPage } = await import(
        "@/components/pages_public/login/LoginPage"
      );
      return { Component: LoginPage };
    },
  },
  {
    name: "SSO",
    path: "/sso",
    lazy: async () => {
      const { SSOPage: SSO } = await import(
        "@/components/pages_public/sso/SSOPage"
      );
      return { Component: SSO };
    },
  },
  {
    name: "About",
    path: "/about-us",
    lazy: async () => {
      const { About } = await import("@/components/pages_public/about");
      return { Component: About };
    },
  },
  {
    name: "EnterprisePrivacy",
    path: "/enterprise-privacy",
    lazy: async () => {
      const { EnterpriseAI } = await import(
        "@/components/pages_public/enterprise-privacy"
      );
      return { Component: EnterpriseAI };
    },
  },
  {
    name: "Demo",
    path: "/demo",
    lazy: async () => {
      const { Demo } = await import("@/components/pages_public/demo");
      return { Component: Demo };
    },
  },
  {
    name: "GetDemoInc",
    path: "/get-demo-inc",
    lazy: async () => {
      const { GetDemoInc } = await import(
        "@/components/pages_public/get-demo-inc"
      );
      return { Component: GetDemoInc };
    },
  },
  {
    name: "Unsubscribe",
    path: "/unsubscribe",
    lazy: async () => {
      const { UnsubscribePage } = await import(
        "@/components/pages_public/unsubscribe/UnsubscribePage"
      );
      return { Component: UnsubscribePage };
    },
  },
  {
    name: "Redeem",
    path: "/redeem",
    lazy: async () => {
      const { RedeemPage: Redeem } = await import(
        "@/components/pages_flexible/redeem/RedemPage"
      );
      return { Component: Redeem };
    },
  },
  {
    name: "Pro",
    path: "/pro",
    lazy: async () => {
      const { PlacementHomePage } = await import(
        "@/components/pages_public/home"
      );
      return { Component: PlacementHomePage };
    },
  },
  {
    name: "LPCoaching",
    path: "/career-coaching",
    lazy: async () => {
      const { PlacementLPCoachingPage } = await import(
        "@/components/pages_public/lp-coaching"
      );
      return { Component: PlacementLPCoachingPage };
    },
  },
  {
    name: "LPCoaching",
    path: "/life-coaching",
    lazy: async () => {
      const { PlacementLPCoachingPage } = await import(
        "@/components/pages_public/lp-coaching"
      );
      return { Component: PlacementLPCoachingPage };
    },
  },
  {
    name: "LPCoaching",
    path: "/leadership-coaching",
    lazy: async () => {
      const { PlacementLPCoachingPage } = await import(
        "@/components/pages_public/lp-coaching"
      );
      return { Component: PlacementLPCoachingPage };
    },
  },
  {
    name: "LPCoaching",
    path: "/job-search-coaching",
    lazy: async () => {
      const { PlacementLPCoachingPage } = await import(
        "@/components/pages_public/lp-coaching"
      );
      return { Component: PlacementLPCoachingPage };
    },
  },
  {
    name: "LPCoaching",
    path: "/b2b-leadership",
    lazy: async () => {
      const { PlacementLPCoachingPage } = await import(
        "@/components/pages_public/lp-coaching"
      );
      return { Component: PlacementLPCoachingPage };
    },
  },
  {
    name: "CoachProfile",
    path: "/coaches/:coachSlug",
    lazy: async () => {
      const { CoachPage } = await import(
        "@/components/pages_flexible/coach/CoachProfilePage"
      );
      return { Component: CoachPage };
    },
  },
  {
    name: "CoachSpecialtyProfile",
    path: "/coaches/:coachSlug/:specialtySlug",
    lazy: async () => {
      const { CoachPage } = await import(
        "@/components/pages_flexible/coach/CoachProfilePage"
      );
      return { Component: CoachPage };
    },
  },

  {
    name: "ExploreDetail",
    path: "/explore/:productSlug",
    lazy: async () => {
      const { ExplorePage } = await import(
        "@/components/pages_flexible/explore/ExplorePage"
      );
      return { Component: ExplorePage };
    },
  },
  {
    name: "ExploreDetail",
    path: "/explore/:productSlug/:coachSlug",
    lazy: async () => {
      const { ExplorePage } = await import(
        "@/components/pages_flexible/explore/ExplorePage"
      );
      return { Component: ExplorePage };
    },
  },

  {
    name: "Faq",
    path: "/faq",
    lazy: async () => {
      const { FaqPage } = await import("@/components/pages_public/faq");
      return { Component: FaqPage };
    },
  },
  {
    name: "SignUp",
    path: "/signup",
    lazy: async () => {
      const { SignUp } = await import("@/components/pages_public/signup");
      return { Component: SignUp };
    },
  },
  {
    name: "ForgotPassword",
    path: "/reset-password",
    lazy: async () => {
      const { ResetPasswordPage } = await import(
        "@/components/pages_public/forgot-password/ResetPasswordPage"
      );
      return { Component: ResetPasswordPage };
    },
  },
  {
    name: "ForgotPassword",
    path: "/forgot-password",
    lazy: async () => {
      const { ResetPasswordPage } = await import(
        "@/components/pages_public/forgot-password/ResetPasswordPage"
      );
      return { Component: ResetPasswordPage };
    },
  },
  {
    name: "ResetPassword",
    path: "/reset-password/:refreshToken",
    lazy: async () => {
      const { SetPasswordPage } = await import(
        "@/components/pages_public/reset-password"
      );
      return { Component: SetPasswordPage };
    },
  },
  {
    name: "ActivateMembership",
    path: "/activate-membership/:refreshToken",
    lazy: async () => {
      const { ActivateMembershipPage } = await import(
        "@/components/pages_public/activate-membership/ActivateMembershipPage"
      );
      return { Component: ActivateMembershipPage };
    },
  },
  {
    name: "PrivacyPolicy",
    path: "/privacy-policy",
    lazy: async () => {
      const { PrivacyPolicyPage } = await import(
        "@/components/pages_public/privacy-policy"
      );
      return { Component: PrivacyPolicyPage };
    },
  },
  {
    name: "Tos",
    path: "/tos",
    lazy: async () => {
      const { TosPage } = await import("@/components/pages_public/tos");
      return { Component: TosPage };
    },
  },
  {
    name: "EnterpriseTos",
    path: "/enterprise-tos",
    lazy: async () => {
      const { EnterpriseTosPage } = await import(
        "@/components/pages_public/enterprise-tos"
      );
      return { Component: EnterpriseTosPage };
    },
  },
  {
    name: "SalesCompCalculator",
    path: "/sales-comp",
    lazy: async () => {
      const { SalesCompPage } = await import(
        "@/components/pages_public/sales-comp"
      );
      return { Component: SalesCompPage };
    },
  },

  {
    name: "Learn",
    path: "/learn",
    lazy: async () => {
      const { LearnPage } = await import(
        "@/components/pages_flexible/learn/LearnPage"
      );
      return { Component: LearnPage };
    },
  },
  {
    name: "LearnSeries",
    path: "/learn/series/:slug",
    lazy: async () => {
      const { ArticleSeriesPage } = await import(
        "@/components/pages_flexible/article-series/ArticleSeriesPage"
      );
      return { Component: ArticleSeriesPage };
    },
  },
  {
    name: "LearnArticle",
    path: "/learn/:slug",
    lazy: async () => {
      const { ArticleContainer } = await import(
        "@/components/pages_flexible/article/ArticleContainer"
      );
      return { Component: ArticleContainer };
    },
  },
  {
    name: "LearnOtherArticles",
    path: "/learn/other-articles",
    lazy: async () => {
      const { OtherArticlesPage: OtherArticles } = await import(
        "@/components/pages_flexible/other-articles/OtherArticlesPage"
      );
      return { Component: OtherArticles };
    },
  },

  // authorized pages
  {
    name: "SetPassword",
    path: "/set-password",
    lazy: async () => {
      const { SetPasswordPage } = await import(
        "@/components/pages_logged_in/set-password"
      );
      return { Component: SetPasswordPage };
    },
  },
  {
    name: "App",
    path: "/app",
    lazy: async () => {
      const { AppRedirectPage } = await import(
        "@/components/pages_logged_in/app"
      );
      return { Component: AppRedirectPage };
    },
  },
  {
    name: "Dashboard",
    path: "/dashboard",
    lazy: async () => {
      const { DashboardPage: Dashboard } = await import(
        "@/components/pages_logged_in/dashboard/DashboardPage"
      );
      return { Component: Dashboard };
    },
  },
  {
    name: "Billing",
    path: "/app/billing",
    lazy: async () => {
      const { BillingPage: Billing } = await import(
        "@/components/pages_logged_in/app/billing/BillingPage"
      );
      return { Component: Billing };
    },
  },
  {
    name: "Referrals",
    path: "/referrals",
    lazy: async () => {
      const { ReferralsPage } = await import(
        "@/components/pages_logged_in/app/referrals"
      );
      return { Component: ReferralsPage };
    },
  },
  {
    name: "ProductUpdates",
    path: "/updates",
    lazy: async () => {
      const { ChangelogPage } = await import(
        "@/components/pages_logged_in/changelog/ChangelogPage"
      );
      return { Component: ChangelogPage };
    },
  },
  {
    name: "ProductUpdateEntry",
    path: "/updates/:slug",
    lazy: async () => {
      const { ChangelogEntryPage } = await import(
        "@/components/pages_logged_in/changelog/ChangelogEntryPage"
      );
      return { Component: ChangelogEntryPage };
    },
  },
  {
    name: "Rubrics",
    path: "/rubrics",
    lazy: async () => {
      const { RubricsPage: Component } = await import(
        "@/components/pages_logged_in/rubrics/RubricsPage"
      );
      return { Component };
    },
  },
  {
    name: "RubricDetail",
    path: "/rubrics/:uuid",
    lazy: async () => {
      const { RubricDetailPage: Component } = await import(
        "@/components/pages_logged_in/rubrics/detail/RubricDetailPage"
      );
      return { Component };
    },
  },
  {
    name: "Certifications",
    path: "/certifications",
    lazy: async () => {
      const { CertificationsPage: Component } = await import(
        "@/components/pages_logged_in/certifications/CertificationsPage"
      );
      return { Component };
    },
  },
  {
    name: "CreateCertification",
    path: "/certifications/create",
    lazy: async () => {
      const { CertificationsPage: Component } = await import(
        "@/components/pages_logged_in/certifications/CertificationsPage"
      );
      return { Component };
    },
  },
  {
    name: "CertificationDetails",
    path: "/certifications/:id",
    lazy: async () => {
      const { CertificationDetailsPage: Component } = await import(
        "@/components/pages_logged_in/certifications/CertificationDetailsPage"
      );
      return { Component };
    },
  },
  {
    name: "EditCertification",
    path: "/certifications/:id/edit",
    lazy: async () => {
      const { CertificationDetailsPage: Component } = await import(
        "@/components/pages_logged_in/certifications/CertificationDetailsPage"
      );
      return { Component };
    },
  },
  {
    name: "CertificateDownload",
    path: "/certificates/:id",
    lazy: async () => {
      const { CertificateDownloadPage } = await import(
        "@/components/pages_logged_in/certifications/CertificateDownloadPage"
      );
      return { Component: CertificateDownloadPage };
    },
  },
  {
    name: "WorkspaceAnalytics",
    path: "/analytics",
    lazy: async () => {
      const { WorkspaceAnalyticsPage } = await import(
        "@/components/pages_logged_in/workspace-admin/WorkspaceAnalytics"
      );
      return { Component: WorkspaceAnalyticsPage };
    },
  },
  {
    name: "Checkout",
    path: "/checkout/:id",
    lazy: async () => {
      const { CheckoutPage: Checkout } = await import(
        "@/components/pages_logged_in/checkout/CheckoutPage"
      );
      return { Component: Checkout };
    },
  },
  {
    name: "CheckoutNextSteps",
    path: "/checkout/:id/next-steps",
    lazy: async () => {
      const { CheckoutNextStepsPage } = await import(
        "@/components/pages_logged_in/checkout/next-steps/CheckoutNextStepsPage"
      );
      return { Component: CheckoutNextStepsPage };
    },
  },
  {
    name: "BuyCredits",
    path: "/buy",
    lazy: async () => {
      const { BuyCreditsPage } = await import(
        "@/components/pages_logged_in/buy-credits/BuyCreditsPage"
      );
      return { Component: BuyCreditsPage };
    },
  },
  {
    name: "BuyCreditsSuccess",
    path: "/buy/success/:id",
    lazy: async () => {
      const { BuyCreditsSuccessPage } = await import(
        "@/components/pages_logged_in/buy-credits/success"
      );
      return { Component: BuyCreditsSuccessPage };
    },
  },
  {
    name: "BuyCreditsProduct",
    path: "/buy/:slug",
    lazy: async () => {
      const { BuyCreditsPage } = await import(
        "@/components/pages_logged_in/buy-credits/BuyCreditsPage"
      );
      return { Component: BuyCreditsPage };
    },
  },
  {
    name: "TransferCredits",
    path: "/transfer",
    lazy: async () => {
      const { TransferCredits } = await import(
        "@/components/pages_logged_in/transfer-credits"
      );
      return { Component: TransferCredits };
    },
  },
  {
    name: "Coaching",
    path: "/coaching",
    lazy: async () => {
      const { CoachingPage } = await import(
        "@/components/pages_logged_in/coaching/CoachingPage"
      );
      return { Component: CoachingPage };
    },
  },
  {
    name: "Home",
    path: "/home",
    lazy: async () => {
      const { Home } = await import(
        "@/components/pages_logged_in/home/HomePage"
      );
      return { Component: Home };
    },
  },
  {
    name: "Payouts",
    path: "/payouts",
    lazy: async () => {
      const { PayoutsPage } = await import(
        "@/components/pages_logged_in/payouts/PayoutsPage"
      );
      return { Component: PayoutsPage };
    },
  },
  {
    name: "Availability",
    path: "/availability",
    lazy: async () => {
      const { AvailabilityPage } = await import(
        "@/components/pages_logged_in/availability/AvailabilityPage"
      );
      return { Component: AvailabilityPage };
    },
  },
  {
    name: "Services",
    path: "/services",
    lazy: async () => {
      const { ServicesPage } = await import(
        "@/components/pages_logged_in/services/ServicesPage"
      );
      return { Component: ServicesPage };
    },
  },
  {
    name: "ServiceDetail",
    path: "/services/:productId",
    lazy: async () => {
      const { ServiceDetailPage } = await import(
        "@/components/pages_logged_in/services/ServiceDetailPage"
      );
      return { Component: ServiceDetailPage };
    },
  },
  {
    name: "Sessions",
    path: "/sessions",
    lazy: async () => {
      const { SessionsPage } = await import(
        "@/components/pages_logged_in/sessions/SessionsPage"
      );
      return { Component: SessionsPage };
    },
  },
  {
    name: "Session",
    path: "/sessions/:meetingId",
    lazy: async () => {
      const { SessionPage } = await import(
        "@/components/pages_logged_in/session/SessionPage"
      );
      return { Component: SessionPage };
    },
  },
  {
    name: "Reviews",
    path: "/reviews",
    lazy: async () => {
      const { ReviewsPage } = await import(
        "@/components/pages_logged_in/reviews/ReviewsPage"
      );
      return { Component: ReviewsPage };
    },
  },
  {
    name: "Review",
    path: "/reviews/:reviewId",
    lazy: async () => {
      const { ReviewPage } = await import(
        "@/components/pages_logged_in/review/ReviewPage"
      );
      return { Component: ReviewPage };
    },
  },
  {
    name: "Rate",
    path: "/rate",
    lazy: async () => {
      const { RatePage } = await import(
        "@/components/pages_logged_in/rate/RatePage"
      );
      return { Component: RatePage };
    },
  },
  {
    name: "RateEdit",
    path: "/rate/:ratingId",
    lazy: async () => {
      const { RatePage } = await import(
        "@/components/pages_logged_in/rate/RatePage"
      );
      return { Component: RatePage };
    },
  },
  {
    name: "Reschedule",
    path: "/sessions/:meetingId/reschedule",
    lazy: async () => {
      const { ReschedulePage } = await import(
        "@/components/pages_logged_in/schedule/reschedule/ReschedulePage"
      );
      return { Component: ReschedulePage };
    },
  },
  {
    name: "AssignedScenarios",
    path: "/roleplays/assigned",
    lazy: async () => {
      const { AssignedScenariosPage } = await import(
        "@/components/pages_logged_in/roleplays/scenarios/AssignedScenarios"
      );
      return { Component: AssignedScenariosPage };
    },
  },
  {
    name: "PersonalScenarios",
    path: "/roleplays/personal",
    lazy: async () => {
      const { PersonalScenariosPage } = await import(
        "@/components/pages_logged_in/roleplays/scenarios/PersonalScenarios"
      );
      return { Component: PersonalScenariosPage };
    },
  },
  {
    name: "Roleplays",
    path: "/roleplays",
    lazy: async () => {
      const { RoleplaysListPage } = await import(
        "@/components/pages_logged_in/roleplays"
      );
      return { Component: RoleplaysListPage };
    },
  },
  {
    name: "RoleplayAssignment",
    path: "/roleplays/assignments",
    lazy: async () => {
      const { RoleplayAssignmentPage } = await import(
        "@/components/pages_logged_in/roleplays/RoleplayAssignmentPage"
      );
      return { Component: RoleplayAssignmentPage };
    },
  },
  {
    name: "RoleplayDetail",
    path: "/roleplays/:slug",
    lazy: async () => {
      const { RoleplayDetailPage } = await import(
        "@/components/pages_logged_in/roleplays/details"
      );
      return { Component: RoleplayDetailPage };
    },
  },
  {
    name: "RoleplayDetail",
    path: "/roleplays/create",
    lazy: async () => {
      const { RoleplayDetailPage } = await import(
        "@/components/pages_logged_in/roleplays/details"
      );
      return { Component: RoleplayDetailPage };
    },
  },
  {
    name: "ScenarioCreate",
    path: "/roleplays/scenarios/create",
    lazy: async () => {
      const { ScenarioCreatePage } = await import(
        "@/components/pages_logged_in/roleplays/details/create"
      );
      return { Component: ScenarioCreatePage };
    },
  },
  {
    name: "ScenarioCreate",
    path: "/roleplays/:slug/create",
    lazy: async () => {
      const { ScenarioCreatePage } = await import(
        "@/components/pages_logged_in/roleplays/details/create"
      );
      return { Component: ScenarioCreatePage };
    },
  },
  {
    name: "IntakeProcessing",
    path: "/roleplays/intake/:intakeUuid",
    lazy: async () => {
      const { IntakeProcessingPage } = await import(
        "@/components/pages_logged_in/roleplays/intake"
      );
      return { Component: IntakeProcessingPage };
    },
  },
  {
    name: "ScenarioDetail",
    path: "/roleplays/:roleplaySlug/:scenarioSlug",
    lazy: async () => {
      const { ScenarioPage } = await import(
        "@/components/pages_logged_in/roleplays/details/scenario"
      );
      return { Component: ScenarioPage };
    },
  },
  {
    name: "ScenarioAssignment",
    path: "/scenarios/:scenarioSlug/assignment",
    lazy: async () => {
      const { ScenarioAssignmentPage } = await import(
        "@/components/pages_logged_in/roleplays/details/scenario/ScenarioAssignmentPage"
      );
      return { Component: ScenarioAssignmentPage };
    },
  },
  {
    name: "ScenarioDetail",
    path: "/scenarios/:scenarioSlug",
    lazy: async () => {
      const { ScenarioPage } = await import(
        "@/components/pages_logged_in/roleplays/details/scenario"
      );
      return { Component: ScenarioPage };
    },
  },
  {
    name: "RoleplaySessionDetail",
    path: "/scenarios/:scenarioSlug/:sessionUuid/:view?",
    lazy: async () => {
      const { RoleplaySessionPage } = await import(
        "@/components/pages_logged_in/roleplays/details/scenario/session"
      );
      return { Component: RoleplaySessionPage };
    },
  },
  {
    name: "RoleplaySessionDetail",
    path: "/roleplays/:roleplaySlug/:scenarioSlug/:sessionUuid/:view?",
    lazy: async () => {
      const { RoleplaySessionPage } = await import(
        "@/components/pages_logged_in/roleplays/details/scenario/session"
      );
      return { Component: RoleplaySessionPage };
    },
  },
  {
    name: "Onboard",
    path: "/onboard",
    lazy: async () => {
      const { OnboardPage } = await import(
        "@/components/pages_logged_in/onboard"
      );
      return { Component: OnboardPage };
    },
  },
  {
    name: "Match",
    path: "/match",
    lazy: async () => {
      const { MatchStartPage } = await import(
        "@/components/pages_flexible/match/MatchStartPage"
      );
      return { Component: MatchStartPage };
    },
  },
  {
    name: "Match",
    path: "/match/specialty-select",
    lazy: async () => {
      const { SpecialtySelectPage } = await import(
        "@/components/pages_flexible/match/specialty/SpecialtySelectPage"
      );
      return { Component: SpecialtySelectPage };
    },
  },
  {
    name: "MatchSpecialty",
    path: "/match/:specialtySlug",
    lazy: async () => {
      const { SpecialtySelectedFlow } = await import(
        "@/components/pages_flexible/match/specialty/SpecialtySelectedFlow"
      );
      return { Component: SpecialtySelectedFlow };
    },
  },
  {
    name: "Choose",
    path: "/choose",
    lazy: async () => {
      const { ChoosePage } = await import(
        "@/components/pages_flexible/choose/ChoosePage"
      );
      return { Component: ChoosePage };
    },
  },
  {
    name: "Choose",
    path: "/choose/:specialtySlug",
    lazy: async () => {
      const { ChoosePage } = await import(
        "@/components/pages_flexible/choose/ChoosePage"
      );
      return { Component: ChoosePage };
    },
  },
  {
    name: "FulfillmentForm",
    path: "/forms/:orderId",
    lazy: async () => {
      const { FormFlowPage: FormFlowContainer } = await import(
        "@/components/pages_logged_in/fulfillment-forms/FormFlowPage"
      );
      return { Component: FormFlowContainer };
    },
  },
  {
    name: "TrackSubscription",
    path: "/track/subscribed/",
    lazy: async () => {
      const { Subscribed } = await import(
        "@/components/pages_logged_in/subscribed"
      );
      return { Component: Subscribed };
    },
  },
  {
    name: "Subscribed",
    path: "/subscribed/",
    lazy: async () => {
      const { Subscribed } = await import(
        "@/components/pages_logged_in/subscribed"
      );
      return { Component: Subscribed };
    },
  },
  {
    name: "SubscribeCheckout",
    path: "/subscribe/checkout",
    lazy: async () => {
      const { SubscribeCheckout } = await import(
        "@/components/pages_logged_in/subscribe-checkout"
      );
      return { Component: SubscribeCheckout };
    },
  },

  // Workspace client pages
  {
    name: "WorkspaceClients",
    path: "/clients",
    lazy: async () => {
      const { ClientStaffPage } = await import(
        "@/components/pages_logged_in/workspace/clients/ClientStaffPage"
      );
      return { Component: ClientStaffPage };
    },
  },
  {
    name: "WorkspaceMessages",
    path: "/messages",
    lazy: async () => {
      const { WorkspaceMessagesPage } = await import(
        "@/components/pages_logged_in/workspace/messages/WorkspaceMessagesPage"
      );
      return { Component: WorkspaceMessagesPage };
    },
  },
  {
    name: "WorkspaceClientProfile",
    path: "/client/:userId",
    lazy: async () => {
      const { ClientProfilePage } = await import(
        "@/components/pages_logged_in/workspace/profile/ClientProfilePage"
      );
      return { Component: ClientProfilePage };
    },
  },
  {
    name: "WorkspaceClientBuyCredits",
    path: "/client/:userId/buy",
    lazy: async () => {
      const { ClientBuyCreditsPage: WorkspaceClientBuyCredits } = await import(
        "@/components/pages_logged_in/workspace/buy-credits/ClientBuyCreditsPage"
      );
      return { Component: WorkspaceClientBuyCredits };
    },
  },
  {
    name: "WorkspaceClientBuyCreditsSuccess",
    path: "/client/:userId/buy/success/:id",
    lazy: async () => {
      const { ClientBuyCreditsSuccess: WorkspaceClientBuyCreditsSuccess } =
        await import(
          "@/components/pages_logged_in/workspace/buy-credits/success/ClientBuyCreditsSuccess"
        );
      return { Component: WorkspaceClientBuyCreditsSuccess };
    },
  },
  {
    name: "WorkspaceClientBuyCreditsProduct",
    path: "/client/:userId/buy/:slug",
    lazy: async () => {
      const { ClientBuyCreditsPage: WorkspaceClientBuyCredits } = await import(
        "@/components/pages_logged_in/workspace/buy-credits/ClientBuyCreditsPage"
      );
      return { Component: WorkspaceClientBuyCredits };
    },
  },
  {
    name: "WorkspaceClientSessions",
    path: "/client/:userId/sessions",
    lazy: async () => {
      const { ClientSessionsPage } = await import(
        "@/components/pages_logged_in/workspace/sessions/ClientSessionsPage"
      );
      return { Component: ClientSessionsPage };
    },
  },
  {
    name: "WorkspaceClientReviews",
    path: "/client/:userId/reviews",
    lazy: async () => {
      const { ClientReviewsPage: WorkspaceReviewsPage } = await import(
        "@/components/pages_logged_in/workspace/reviews/ClientReviews"
      );
      return { Component: WorkspaceReviewsPage };
    },
  },
  {
    name: "WorkspaceClientMessages",
    path: "/client/:userId/messages",
    lazy: async () => {
      const { WorkspaceMessagesPage: WorkspaceMessages } = await import(
        "@/components/pages_logged_in/workspace/messages/client/WorkspaceMessagesPage"
      );
      return { Component: WorkspaceMessages };
    },
  },
  {
    name: "WorkspaceClientMessagesChannel",
    path: "/client/:userId/messages/:channelId",
    lazy: async () => {
      const { WorkspaceMessagesPage: WorkspaceMessages } = await import(
        "@/components/pages_logged_in/workspace/messages/client/WorkspaceMessagesPage"
      );
      return { Component: WorkspaceMessages };
    },
  },
  {
    name: "WorkspaceMessagesUser",
    path: "/messages/:userId/channels",
    lazy: async () => {
      const { WorkspaceMessagesPage } = await import(
        "@/components/pages_logged_in/workspace/messages/WorkspaceMessagesPage"
      );
      return { Component: WorkspaceMessagesPage };
    },
  },
  {
    name: "WorkspaceMessagesUser",
    path: "/messages/:userId",
    lazy: async () => {
      const { WorkspaceMessagesPage } = await import(
        "@/components/pages_logged_in/workspace/messages/WorkspaceMessagesPage"
      );
      return { Component: WorkspaceMessagesPage };
    },
  },
  {
    name: "WorkspaceMessagesChannel",
    path: "/messages/:userId/channels/:channelId",
    lazy: async () => {
      const { WorkspaceMessagesPage } = await import(
        "@/components/pages_logged_in/workspace/messages/WorkspaceMessagesPage"
      );
      return { Component: WorkspaceMessagesPage };
    },
  },
  {
    name: "CallScorecardDetail",
    path: "/scorecards/:uuid",
    lazy: async () => {
      const { CallScorecardDetail } = await import(
        "@/components/pages_logged_in/call-scoring/scorecards/CallScorecardDetail"
      );
      return { Component: CallScorecardDetail };
    },
  },

  // Workspace admin pages
  {
    name: "WorkspaceAdmin",
    path: "/workspace/",
    lazy: async () => {
      const { WorkspaceAdminPage } = await import(
        "@/components/pages_logged_in/workspace-admin/WorkspaceAdminPage"
      );
      return { Component: WorkspaceAdminPage };
    },
  },
  {
    name: "WorkspaceAdmin",
    path: "/workspace/users",
    lazy: async () => {
      const { WorkspaceAdminPage } = await import(
        "@/components/pages_logged_in/workspace-admin/WorkspaceAdminPage"
      );
      return { Component: WorkspaceAdminPage };
    },
  },
  {
    name: "WorkspaceGroups",
    path: "/workspace/groups",
    lazy: async () => {
      const { WorkspaceGroupsPage } = await import(
        "@/components/pages_logged_in/workspace-admin/WorkspaceGroupsPage"
      );
      return { Component: WorkspaceGroupsPage };
    },
  },
  {
    name: "WorkspaceGroup",
    path: "/workspace/groups/:groupId",
    lazy: async () => {
      const { WorkspaceGroupPage } = await import(
        "@/components/pages_logged_in/workspace-admin/WorkspaceGroupPage"
      );
      return { Component: WorkspaceGroupPage };
    },
  },
  {
    name: "WorkspaceSettings",
    path: "/workspace/settings",
    lazy: async () => {
      const { WorkspaceSettingsPage } = await import(
        "@/components/pages_logged_in/workspace-admin/WorkspaceSettingsPage"
      );
      return { Component: WorkspaceSettingsPage };
    },
  },
  {
    name: "WorkspaceBilling",
    path: "/workspace/billing",
    lazy: async () => {
      const { WorkspaceBillingPage } = await import(
        "@/components/pages_logged_in/workspace-admin/WorkspaceBillingPage"
      );
      return { Component: WorkspaceBillingPage };
    },
  },
  {
    name: "WorkspaceIntegrations",
    path: "/workspace/integrations",
    lazy: async () => {
      const { WorkspaceIntegrations } = await import(
        "@/components/pages_logged_in/workspace-admin/WorkspaceIntegrations"
      );
      return { Component: WorkspaceIntegrations };
    },
  },
  {
    name: "WorkspaceDashboard",
    path: "/workspace-dashboard",
    lazy: async () => {
      const { WorkspaceDashboard } = await import(
        "@/components/pages_logged_in/workspace-admin/WorkspaceDashboard"
      );
      return { Component: WorkspaceDashboard };
    },
  },
  {
    name: "OutlookAuthorize",
    path: "/outlook-authorize",
    lazy: async () => {
      const { OutlookAuthorizePage } = await import(
        "@/components/pages_logged_in/outlook-authorize"
      );
      return { Component: OutlookAuthorizePage };
    },
  },

  // Program pages
  {
    name: "Program",
    path: "/programs",
    lazy: async () => {
      const { ProgramListPage } = await import(
        "@/components/pages_logged_in/program/pages/program-list/ProgramListPage"
      );
      return { Component: ProgramListPage };
    },
  },
  {
    name: "ProgramParticipants",
    path: "/programs/:id/participants",
    lazy: async () => {
      const { ProgramParticipantPage } = await import(
        "@/components/pages_logged_in/program/pages/program-participants/ProgramParticipantsPage"
      );
      return { Component: ProgramParticipantPage };
    },
  },
  {
    name: "ProgramDashboard",
    path: "/programs/:id",
    lazy: async () => {
      const { ProgramDashboardPage } = await import(
        "@/components/pages_logged_in/program/pages/program-dashboard/ProgramDashboardPage"
      );
      return { Component: ProgramDashboardPage };
    },
  },
  {
    name: "ProgramDetails",
    path: "/programs/:id/:view",
    lazy: async () => {
      const { ProgramDetailsPage } = await import(
        "@/components/pages_logged_in/program/pages/program-details/ProgramDetailsPage"
      );
      return { Component: ProgramDetailsPage };
    },
  },
  {
    name: "ProgramDetails",
    path: "/programs/:id/:view/:componentId",
    lazy: async () => {
      const { ProgramDetailsPage } = await import(
        "@/components/pages_logged_in/program/pages/program-details/ProgramDetailsPage"
      );
      return { Component: ProgramDetailsPage };
    },
  },
  {
    name: "ProgramDetails",
    path: "/programs/:id/:view/:componentId/:responseId",
    lazy: async () => {
      const { ProgramDetailsPage } = await import(
        "@/components/pages_logged_in/program/pages/program-details/ProgramDetailsPage"
      );
      return { Component: ProgramDetailsPage };
    },
  },
  {
    name: "ProgramSurvey",
    path: "/surveys/:id",
    lazy: async () => {
      const { ProgramSurveyPage } = await import(
        "@/components/pages_logged_in/program/pages/program-survey/ProgramSurveyPage"
      );
      return { Component: ProgramSurveyPage };
    },
  },
  {
    name: "ActivateParticipant",
    path: "/activate-participant/:programId/:refreshToken",
    lazy: async () => {
      const { ActivateParticipantPage } = await import(
        "@/components/pages_logged_in/program/pages/activate-participant"
      );
      return { Component: ActivateParticipantPage };
    },
  },
  {
    name: "SelectCoach",
    path: "/schedule",
    lazy: async () => {
      const { SelectCoachPage } = await import(
        "@/components/pages_logged_in/schedule/SelectCoachPage"
      );
      return { Component: SelectCoachPage };
    },
  },
  {
    name: "Schedule",
    path: "/schedule/:coachId",
    lazy: async () => {
      const { SchedulePage } = await import(
        "@/components/pages_logged_in/schedule/SchedulePage"
      );
      return { Component: SchedulePage };
    },
  },
];

const PLACEMENT_ONLY: Route[] = [
  {
    name: "Home",
    path: "/",
    lazy: async () => {
      const { PlacementHomePage } = await import(
        "@/components/pages_public/home"
      );
      return { Component: PlacementHomePage };
    },
  },
];

const EXEC_ONLY: Route[] = [
  {
    name: "ExecHome",
    path: "/",
    lazy: async () => {
      const { ExecHomePage } = await import(
        "@/components/pages_public/exec-home"
      );

      return { Component: ExecHomePage };
    },
  },
  {
    name: "CoachingPlatform",
    path: "/coaching-platform",
    lazy: async () => {
      const { CoachingPlatformPage } = await import(
        "@/components/pages_public/coaching-platform"
      );

      return { Component: CoachingPlatformPage };
    },
  },
  {
    name: "Platform",
    path: "/platform",
    lazy: async () => {
      const { PlatformPage } = await import(
        "@/components/pages_public/platform"
      );

      return { Component: PlatformPage };
    },
  },
  {
    name: "Start",
    path: "/start",
    lazy: async () => {
      const { StartPage } = await import("@/components/pages_public/start");
      return { Component: StartPage };
    },
  },
  {
    name: "CreateWorkspace",
    path: "/create-workspace",
    lazy: async () => {
      const { CreateWorkspacePage } = await import(
        "@/components/pages_public/create-workspace"
      );

      return { Component: CreateWorkspacePage };
    },
  },
  {
    name: "ScheduleDemo",
    path: "/schedule-demo",
    lazy: async () => {
      const { ScheduleDemoPage } = await import(
        "@/components/pages_logged_in/schedule-demo"
      );

      return { Component: ScheduleDemoPage };
    },
  },
  {
    name: "GetDemo",
    path: "/get-demo",
    lazy: async () => {
      const { ScheduleDemoPage } = await import(
        "@/components/pages_logged_in/get-demo"
      );

      return { Component: ScheduleDemoPage };
    },
  },
  {
    name: "ForCoaches",
    path: "/for-coaches",
    lazy: async () => {
      const { ForCoachesPage } = await import(
        "@/components/pages_public/for-coaches"
      );

      return { Component: ForCoachesPage };
    },
  },
  {
    name: "ForIndividuals",
    path: "/for-individuals",
    lazy: async () => {
      const { ForIndividualsPage } = await import(
        "@/components/pages_public/for-individuals"
      );

      return { Component: ForIndividualsPage };
    },
  },
  {
    name: "ExecDevelopment",
    path: "/exec-development",
    lazy: async () => {
      const { ExecDevelopment } = await import(
        "@/components/pages_public/exec-development"
      );

      return { Component: ExecDevelopment };
    },
  },
  {
    name: "ManagerGrowth",
    path: "/manager-growth",
    lazy: async () => {
      const { ManagerGrowthPage } = await import(
        "@/components/pages_public/manager-growth"
      );

      return { Component: ManagerGrowthPage };
    },
  },
  {
    name: "HighPotentials",
    path: "/hipo-program",
    lazy: async () => {
      const { HighPotentials } = await import(
        "@/components/pages_public/high-potentials"
      );

      return { Component: HighPotentials };
    },
  },
  {
    name: "Outplacement",
    path: "/outplacement",
    lazy: async () => {
      const { OutplacementPage } = await import(
        "@/components/pages_public/outplacement"
      );

      return { Component: OutplacementPage };
    },
  },
  {
    name: "Outplacement",
    path: "/outplacement/success",
    lazy: async () => {
      const { OutplacementPage } = await import(
        "@/components/pages_public/outplacement"
      );

      return { Component: OutplacementPage };
    },
  },
  {
    name: "Offsites",
    path: "/offsites",
    lazy: async () => {
      const { OffsitesPage } = await import(
        "@/components/pages_public/offsites"
      );

      return { Component: OffsitesPage };
    },
  },
  {
    name: "AIRoleplays",
    path: "/ai-roleplays",
    lazy: async () => {
      const { RoleplaysPage } = await import(
        "@/components/pages_public/role-plays"
      );

      return { Component: RoleplaysPage };
    },
  },
];

const isExec =
  typeof IS_EXEC !== "undefined" ? IS_EXEC : process.env.PRODUCT === "exec";
const particularRoutes = isExec ? EXEC_ONLY : PLACEMENT_ONLY;

const routes: Route[] = [
  ...allRoutes,
  ...particularRoutes,
  {
    name: "CoachProfile",
    path: "/:coachSlug",
    isCatchAllRoute: true,
    lazy: async () => {
      const { CoachPage } = await import(
        "@/components/pages_flexible/coach/CoachProfilePage"
      );
      return { Component: CoachPage };
    },
  },
  {
    name: "CoachSpecialtyProfile",
    path: "/:coachSlug/:specialtySlug",
    lazy: async () => {
      const { CoachPage } = await import(
        "@/components/pages_flexible/coach/CoachProfilePage"
      );
      return { Component: CoachPage };
    },
  },
];

export { routes };
